import { FieldMappingBaseFieldType } from '@monetize/types/app';
import { MFlex } from '../../../../../../components/Monetize';
import { MCustomSelect } from '../../../../../../components/Monetize/MCustomSelect/MCustomSelect';
import { Highlighter } from '../../../../../../components/Monetize/MPageSearchInput/Highlighter';
import { AccountingFieldMappingSearchInput } from './AccountingFieldMappingSearchInput';

type AccountingFieldMappingDropdownProps = {
  placeholder: string;
  fields: FieldMappingBaseFieldType[];
  fieldProps: any;
  index: number;
  side: 'source' | 'target';
  handleOnClear: (idx: number, side: 'source' | 'target') => void;
  onChange: (value: string) => void;
  validateData: (index: number) => void;
  getVariant: (idx: number, side: 'source' | 'target') => 'unsaved' | undefined;
  changeMode: (ev: any, idx: number) => void;
};

export const AccountingFieldMappingDropdown = ({
  placeholder,
  fields,
  fieldProps,
  index,
  side,
  handleOnClear,
  onChange,
  validateData,
  getVariant,
  changeMode,
}: AccountingFieldMappingDropdownProps) => {
  return (
    <MCustomSelect
      isLazy
      returnItem
      clearable
      onClear={() => handleOnClear(index, side)}
      onChange={(ev) => {
        onChange(ev as any);
        validateData(index);
        changeMode(ev, index);
      }}
      itemTitle="displayLabel"
      itemValue="fieldApiName"
      useMainInputAsSearchInput
      internalFilterFields={['displayLabel', 'fieldApiName', 'dataType']}
      MainInputComponent={AccountingFieldMappingSearchInput}
      placeholder={placeholder}
      items={fields}
      useHighlightedItemList
      showItemDivider
      renderItemContent={({ item, query }) => {
        const { dataType, displayLabel, fieldApiName } =
          item as FieldMappingBaseFieldType;
        return (
          <MFlex
            direction="column"
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
          >
            <Highlighter
              title={displayLabel}
              color="tPurple.dark"
              fontSize="sm"
              fontWeight="medium"
              textToHighlight={displayLabel}
              searchWords={[query]}
            />
            <Highlighter
              title={fieldApiName}
              color="tGray.darkPurple"
              fontSize="xs"
              textToHighlight={fieldApiName}
              searchWords={[query]}
            />
            <Highlighter
              title={dataType}
              color="tGray.darkPurple"
              fontSize="xs"
              textTransform="capitalize"
              textToHighlight={dataType}
              searchWords={[query]}
            />
          </MFlex>
        );
      }}
      inputProps={{
        autoComplete: 'off',
        variant: getVariant(index, side),
      }}
      popOverContentProps={{
        width: 'lg',
      }}
      {...fieldProps}
    />
  );
};
